import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useI18n } from "../i18n";

export function NotFoundPage() {
  const { messages } = useI18n();

  return (
    <>
      <Header />
      <main className="not-found shell">
        <p className="eyebrow">{messages.notFound.eyebrow}</p>
        <h1>{messages.notFound.title}</h1>
        <p>{messages.notFound.body}</p>
        <Link className="button" to="/">
          <ArrowLeft className="directional-icon" size={17} aria-hidden="true" />
          {messages.notFound.back}
        </Link>
      </main>
      <Footer />
    </>
  );
}
